import React, {Component, Fragment} from 'react';
import {Alert, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav} from 'reactstrap';
import {connect} from 'react-redux';
import LoadingButton from '../../../shared/ui/LoadingButton';
import trainingPhasesActionCreators from '../../store/training-phases/action-creators/index';
import PhaseReportTable from './PhaseReportTable';
import oitsSelectors from "../../store/oits/selectors";
import departmentSettingsSelectors from "../../store/department-settings/selectors";

class ObservationPhaseDetail extends Component {
  constructor(props) {
    super(props);
    this.state = { dropdownOpen: false };
  }

  // ----------------------
  // Handlers
  // ----------------------

  onAddReport(type) {
    const getResponses = () => {
      if (['dor', 'eop', 'wor'].includes(type)) {
        return [];
      }
      return [];
    };
    const formData = {
      formType: type,
      responses: getResponses(),
      trainingPhaseGuid: this.props.phaseGuid || this.props.selectedPhaseGuid,
    };
    this.props.createReport(formData)
      .then(reportGuid => this.props.editReport(reportGuid));
  }

  // ----------------------
  // Computed
  // ----------------------

  get isPhaseOpened() {
    return this.props.phase.status === 'opened'
      || this.props.phase.status === 'remedial';
  }

  get showAddActionButton() {
    return (this.props.userContext.hasScope(['fto', 'ftoc', 'sup'])
      || this.props.userContext.hasScope(['oit'])) && this.isPhaseOpened

  }

  get critiqueFormTypes() {
    return this.props.settings.critiqueFormTypes ? this.props.settings.critiqueFormTypes : ['ftc'];
  }

  get filteredReports() {
    return this.props.reports.filter(report => {
      if (this.critiqueFormTypes.includes(report.type)) {
        return this.props.canViewCritiqueForms;
      }

      return true;
    })
  }

  // ----------------------
  // Methods
  // ----------------------

  toggleDropdown() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <div>
          {this.showAddActionButton &&
            <Nav className="justify-content-end">
              <Dropdown isOpen={this.state.dropdownOpen} nav toggle={() => this.toggleDropdown()}>
                <DropdownToggle className="dropdown-icon" nav>
                  <LoadingButton
                    primary
                    small
                    text="Add report"
                    icon="fa fa-plus"
                  />
                </DropdownToggle>
                {this.props.userContext.hasScope(['fto', 'ftoc', 'sup']) &&
                  <DropdownMenu right>

                    {this.props.isDorAvailable && (
                      <DropdownItem onClick={() => this.onAddReport('dor')}>Daily Observation Report</DropdownItem>
                    )}
                    {!this.props.phase.hasOpenRemedial && this.props.isEopAvailable &&
                      <DropdownItem onClick={() => this.onAddReport('eop')}>End of Phase Report</DropdownItem>
                    }
                    <div className="dropdown-divider" />
                    {this.props.availableReports.map((report) => (
                      <DropdownItem key={report.type}
                                    onClick={() => this.onAddReport(report.type)}>{report.name}</DropdownItem>
                    ))}
                    {this.props.phase.hasOpenRemedial &&
                      <DropdownItem onClick={() => this.onAddReport('cont')}>Field Training Continuation</DropdownItem>
                    }
                    {!this.props.phase.hasOpenRemedial && this.props.isRrtAvailable &&
                      <DropdownItem onClick={() => this.onAddReport('rrt')}>Request for Additional Training</DropdownItem>
                    }
                  </DropdownMenu>
                }
                {this.props.userContext.hasScope(['oit']) && this.props.myAvailableReports.length &&
                <DropdownMenu right>
                  {this.props.myAvailableReports.map((report) => (
                    <DropdownItem key={report.type}
                                  onClick={() => this.onAddReport(report.type)}>{report.name}</DropdownItem>
                  ))}
                  </DropdownMenu>
                }
              </Dropdown>
            </Nav>
          }
          {!this.props.reports ? (
            <Alert color="primary">No reports found for Training Phase</Alert>
          ) : (
            <PhaseReportTable
              phase={this.props.phase}
              reports={this.filteredReports}
            />
          )}
        </div>
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    reports: state.trainingPhases.reports,
    selectedPhaseGuid: state.trainingPhases.selectedGuid,
    userContext: state.common.userContext,
    availableReports: oitsSelectors.selectedOitAvailableReports(state),
    isEopAvailable: oitsSelectors.isEopAvailable(state),
    isDorAvailable: oitsSelectors.isDorAvailable(state),
    isRrtAvailable: oitsSelectors.isRrtAvailable(state),
    myAvailableReports: oitsSelectors.selectedMyAvailableReports(state),
    selectedOit: oitsSelectors.selectedOit(state),
    settings: state.departmentSettings.settings,
    canViewCritiqueForms: departmentSettingsSelectors.canViewCritiqueForms(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addObservationReport: (type) => {
      return dispatch(trainingPhasesActionCreators.addObservationReport(type));
    },
    editReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.editReport(reportGuid));
    },
    createReport: (formData) => {
      return dispatch(trainingPhasesActionCreators.createReport(formData));
    },
    scheduleReports: () => {
      return dispatch(trainingPhasesActionCreators.scheduleReports());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ObservationPhaseDetail);
